export enum WaybillVerdict {
    Undefined = "Undefined",
    Accepted = "Accepted",
    Rejected = "Rejected"
}

export const WaybillVerdictUtil = {
    getStringValue: (v: WaybillVerdict | null): string => {
        switch (v) {
            case WaybillVerdict.Accepted:
                return "Допуск";
            case WaybillVerdict.Rejected:
                return "Недопуск";
            case WaybillVerdict.Undefined:
            default:
                return "Неизвестно";
        }
    }
};

